/* No analytics library, cookies or outbound URL rewriting. Custom-pixel consumers
 * may subscribe to sx_ticket_click. Fail closed if consent/API is unavailable. */
(() => {
  if (window.sxEventGuideTrackingBound) return;
  window.sxEventGuideTrackingBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-sx-ticket]');
    if (!link || !link.closest('[data-sx-guide], [data-schedule-round]')) return;
    const privacy = window.Shopify?.customerPrivacy;
    const analytics = window.Shopify?.analytics;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    if (typeof analytics?.publish !== 'function') return;
    try {
      Promise.resolve(analytics.publish('sx_ticket_click', {
        event_id: link.dataset.eventId,
        event_handle: link.dataset.eventHandle,
        round: Number(link.dataset.round),
        ticket_provider: link.dataset.provider,
        cta_placement: link.dataset.placement,
        source_page: link.dataset.placement === 'schedule' ? 'schedule' : 'event_guide'
      })).catch(() => {});
    } catch (_) { /* Tracking must never prevent ordinary link navigation. */ }
  });
})();
